import { slugify } from '@src/utils/slugify';
import {
  sortedModules,
  extractFilterValues,
  extractModuleFromALevelRow,
  extractChapterFromALevelRow,
  createNumericalSort,
  sortDifficulty,
} from '@src/components/DynamicTable/helpers';

export const enhanceTopicALevelColumns = (columns, { rows = [] } = {}) => {
  // columns here are already enhanced by defaultColumnEnhancer with basic sorting
  // We only need to add more complex sorting for specific cases
  const enhancedColumns = columns
    .map((col) => {
      const id = slugify(col.id); // Use existing id, just slugify for comparison

      switch (id) {
        case 'module':
          return {
            ...col,
            sortingFn: sortedModules([
              'Pure Year 1',
              'Pure Year 2',
              'Pure Year 1 and 2',
              'Mechs Year 1',
              'Mechs Year 2',
              'Mechs Year 1 and 2',
              'Stats Year 1',
              'Stats Year 2',
              'Stats Year 1 and 2',
            ]),
          };

        case 'textbook-chapter':
          return {
            ...col,
            sortingFn: createNumericalSort('chapter'),
          };

        case 'appearance':
          return {
            ...col,
            sortingFn: createNumericalSort('percent'),
          };

        case 'difficulty':
          return {
            ...col,
            sortingFn: sortDifficulty,
          };

        default:
          // Keep the default enhanced column (sortable already determined by presence of sortingFn)
          return { ...col, sortingFn: undefined };
      }
    })
    .filter(Boolean);

  // Extract filter values if rows are provided
  if (rows.length > 0) {
    const moduleValues = extractFilterValues(rows, extractModuleFromALevelRow);
    const chapterValues = extractFilterValues(rows, extractChapterFromALevelRow);

    // Add filter metadata to the columns object
    if (moduleValues.length > 0 || chapterValues.length > 0) {
      enhancedColumns.filterControls = {
        moduleValues: moduleValues.sort(),
        chapterValues: chapterValues.sort((a, b) => a - b),
      };
    }
  }

  return enhancedColumns;
};

export default enhanceTopicALevelColumns;
